export const hasDuplicateEmployment = (entries = []) => {
  const seen = new Set();

  return (entries ?? []).some(({ jobTitle = "", employer = "" }) => {
    const key = `${String(jobTitle).trim().toLowerCase()}-${String(employer)
      .trim()
      .toLowerCase()}`;

    if (seen.has(key)) return true;
    seen.add(key);
    return false;
  });
};
